import React from "react";
import { Button } from "@mui/material";
import EditIcon from "../../../assets/icons/editIcon.svg";
import { getNairaFormat } from "../../../utils/Utils";
import { canPerformAction, checkForFinance } from "../../../utils/UserAuth";
import {
	AgricultureImage,
	AutomotiveImage,
	ConstructionImage,
	ConsultingImage,
	ECommerceImage,
	EducationImage,
	FashionImage,
	FinancialImage,
	HealthcareImage,
	HospitalityImage,
	ManufacturingImage,
	MediaImage,
	RestaurantImage,
	RetailImage,
	TechnologyImage,
	TransportationImage,
} from "../images/ImagesAf";

/* eslint-disable react/prop-types */
const ActionSideBar = ({
	AFdata,
	action,
	setAction,
	handleCancel,
	canActivateAsset,
	handleRequestActivation,
}) => {
	const handleEdit = () => {
		setAction("edit");
	};

	const businessType = AFdata?.businessType?.toLowerCase();

	const getImgUrl = () => {
		if (AFdata?.productPhotos) {
			return AFdata?.productPhotos[0]?.url;
		} else if (businessType?.includes("restaurant")) {
			return RestaurantImage;
		} else if (businessType?.includes("retail")) {
			return RetailImage;
		} else if (businessType?.includes("technology")) {
			return TechnologyImage;
		} else if (businessType?.includes("consulting")) {
			return ConsultingImage;
		} else if (businessType?.includes("construction")) {
			return ConstructionImage;
		} else if (businessType?.includes("healthcare")) {
			return HealthcareImage;
		} else if (businessType?.includes("e-commerce")) {
			return ECommerceImage;
		} else if (businessType?.includes("manufacturing")) {
			return ManufacturingImage;
		} else if (businessType?.includes("transportation")) {
			return TransportationImage;
		} else if (businessType?.includes("hospitality")) {
			return HospitalityImage;
		} else if (businessType?.includes("finance")) {
			return FinancialImage;
		} else if (businessType?.includes("education")) {
			return EducationImage;
		} else if (businessType?.includes("media")) {
			return MediaImage;
		} else if (businessType?.includes("agriculture")) {
			return AgricultureImage;
		} else if (businessType?.includes("fashion")) {
			return FashionImage;
		} else if (businessType?.includes("automotive")) {
			return AutomotiveImage;
		}
	};

	return (
		<div className='LeftSection'>
			<div className='productDetails'>
				<img src={getImgUrl() || "/images/placeholder_img.jpg"} alt='product' />
				<h6 style={{ textTransform: "capitalize" }}>{AFdata?.businessType}</h6>
				<p>{getNairaFormat(AFdata?.amountToInvest || AFdata?.amountToRaise)}</p>
			</div>

			{canPerformAction("edit", "apprenticeship") &&
				action &&
				(action === "view" ? (
					<Button
						variant='outlined'
						className='editButton'
						onClick={handleEdit}
						startIcon={<img src={EditIcon} alt='edit icon' />}>
						Edit Detail
					</Button>
				) : (
					<>
						<Button variant='contained' className='updateButton' type='submit'>
							Update
						</Button>
						<Button variant='outlined' className='cancelButton' onClick={handleCancel}>
							Cancel
						</Button>
					</>
				))}

			{canActivateAsset && checkForFinance() && (
				<Button
					variant='contained'
					color='success'
					onClick={handleRequestActivation}
					// onClick={handleModalOpen}
					sx={{ mt: 3, px: "48px !important" }}>
					Activate
				</Button>
			)}
		</div>
	);
};

export default ActionSideBar;
